/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Searchplaceholder1Inputs */



/**

* @param {_Wiki_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_searchplaceholder1 = /** @type {((inputs?: _Wiki_Searchplaceholder1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Searchplaceholder1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Wiki durchsuchen...")
});
export { _wiki_searchplaceholder1 as "_wiki_searchPlaceholder" }